import { Component, Input } from '@angular/core';
import { interval, Subject, Subscription } from 'rxjs';

@Component({
    selector: 'app-countdown-timer',
    templateUrl: './countdown-timer.component.html',
    styleUrls: ['./countdown-timer.component.scss'],
    standalone: false
})
export class CountdownTimerComponent {
  @Input() public timerClickSubject: Subject<string>;
  @Input() initialTime: number;
  public timeRemaining: number;
  private timerSubscription$: Subscription;
  public isShowTimer: boolean = false;

  ngOnInit() {
    this.timeRemaining = this.initialTime;

    this.timerClickSubject.subscribe((event) => {
      console.log('EVENT emitted from observable', event); // Todo: remove:
      if (event === 'start') {
        console.log('starting timer...'); // Todo: remove:
        this.startTimer();
      }
      else if (event === 'reset') {
        console.log('resetting timer...'); // Todo: remove:
        this.resetTimer();
      }
    })
  }

  public startTimer() {
    this.isShowTimer = true;
    if (!this.timerSubscription$ || this.timerSubscription$.closed) {
      this.timerSubscription$ = interval(1000).subscribe(() => {
        if (this.timeRemaining > 0) {
          this.timeRemaining--;
        }
        else {
          this.timerSubscription$.unsubscribe();
        }
      })
    }
  }

  public resetTimer() {
    this.isShowTimer = false;
    this.timeRemaining = this.initialTime;
    if (this.timerSubscription$) {
      this.timerSubscription$.unsubscribe();
    }
  }

  public formatTime(timeInSeconds: number): string {
    const minutes = Math.trunc(timeInSeconds / 60);
    const seconds = timeInSeconds % 60
    const displaySeconds = seconds < 10 ? `0${seconds}` : seconds
    let formattedTime: string = `0${minutes}:${displaySeconds}`;
    return formattedTime;
  }

  ngOnDestroy() {
    if (this.timerSubscription$) {
      this.timerSubscription$.unsubscribe();
    }
  }
}
